import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { UpdateObjectInstanceCommand,  useUpdateObjectMutation } from "../../../../services/objects";
import { CostRateEditForm, CO2RateEditForm, IEnergyRate, schemaCO2Rate, schemaCostRate } from "..";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";
import ReferencedCountersList from "../ReferencedCountersList";

interface EditEnergyRateModalProps extends IEnergyRate {
    isOpen: boolean
    onClose: any
}
const EditEnergyRateModal = (props: EditEnergyRateModalProps) => {

    const [updateObject, updateObjectResult] = useUpdateObjectMutation();
    useReportMutationState(updateObjectResult, () => props.onClose());
    
    const [hasChanges,setHasChanges] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [rate, setRate] = useState<any>(props);

    const handleOkClick = (e) => {
        const cmd: UpdateObjectInstanceCommand = {
            objectId: props.id,
            resourceGroupid: props.resourceGroupId,
            name: rate.name,
            properties: getUpdateProperties(rate)
        }
        updateObject(cmd);
    }
    const handleRateChanged = (newState: any) => { setRate(newState); setHasChanges(true); setIsValid(newState.isValid) }


    return (

        <Modal role={'dialog'} animate closeable onClose={props.onClose} isOpen={props.isOpen}>
            <ModalHeader>
                <FormattedMessage id="EditEnergyRateButton.Header" defaultMessage="Edit Energy Rate"></FormattedMessage>
            </ModalHeader>
            <ModalBody>
                
                {props.schema === schemaCostRate && <CostRateEditForm onChange={handleRateChanged} {...rate}></CostRateEditForm>}
                {props.schema === schemaCO2Rate && <CO2RateEditForm onChange={handleRateChanged} {...rate}></CO2RateEditForm>}
                <ReferencedCountersList maxHeight={'200px'} {...props}></ReferencedCountersList>
            </ModalBody>
            <ModalFooter>
                <ModalButton kind="tertiary" onClick={props.onClose}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage>
                </ModalButton>
                <ModalButton onClick={handleOkClick} disabled={!isValid || !hasChanges} isLoading={updateObjectResult.isLoading}>
                    <FormattedMessage id="ok" defaultMessage="Ok"></FormattedMessage>
                </ModalButton>
            </ModalFooter>
        </Modal>

    )
}

export default EditEnergyRateModal;

const getUpdateProperties = (rate: any) => {
    let properties = [
        { key: "valuePerUnit", value: rate.valuePerUnit },
    ]
    if (rate.currencyCode)
        properties.push({ key: "currencyCode", value: rate.currencyCode })
    return properties;
}